import React, { useState } from 'react'
import styled from 'styled-components'
import { useIsClient } from 'usehooks-ts'
import { useIsDesktop } from 'utils/hooks'
import { getLocalStorage, setLocalStorage } from 'utils/storages'
import { Card } from 'components/common/card'
import { Modal } from 'components/common/modal'
import { SmallText } from 'components/common/text'
import { CREDIT_CHARGE_URL, HIDE_CREDIT_AD_KEY } from 'infra/constants'
import { Credit } from 'components/dashboard/pricing-landing'
import { BtnType, Button } from 'components/common/button'
import { MyLink } from 'components/common/link'
import { Row } from 'components/common/layout'

export const CreditAdModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true)
  const isDesktop = useIsDesktop()
  const isClient = useIsClient()
  const shouldNotShowAgain = getLocalStorage<boolean>(HIDE_CREDIT_AD_KEY, false) // 다시 보지 않기 했을 때
  const hasClosed = isClient && !!sessionStorage.getItem(HIDE_CREDIT_AD_KEY) // X 버튼 눌렀을 때
  if (!isClient || !isDesktop || !isOpen || shouldNotShowAgain || hasClosed)
    return null
  return (
    <Modal
      onClose={() => {
        sessionStorage.setItem(HIDE_CREDIT_AD_KEY, JSON.stringify(true))
        setIsOpen(false)
      }}
      width={760}
      disableBackgroundClick
    >
      <ModalCard>
        <ButtonText
          onClick={() => {
            setLocalStorage(HIDE_CREDIT_AD_KEY, true)
            setIsOpen(false)
          }}
        >
          다시 보지 않기
        </ButtonText>
        <Credit />
        <Row
          style={{ position: 'sticky', bottom: 32, justifyContent: 'center' }}
        >
          <MyLink newTab href={CREDIT_CHARGE_URL}>
            <Button
              variant={BtnType.LINEAR}
              style={{
                width: 380,
                boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.2)',
              }}
            >
              💳 크레딧 충전하고 혜택 받기
            </Button>
          </MyLink>
        </Row>
      </ModalCard>
    </Modal>
  )
}

const ModalCard = styled(Card)`
  padding: 48px 32px 32px;
  gap: 24px;
`

const ButtonText = styled(SmallText)`
  position: absolute;
  right: 48px;
  top: 20px;
  color: ${(p) => p.theme.color.gray1};
  text-decoration: underline;
  cursor: pointer;
`
